import {
  KEYWORD_TYPES,
  AddKeywordAction,
  EditKeywordAction,
  GetAllKeywordsAction,
  GetAllKeywordsSuccessAction,
  GetOneKeywordAction,
  GetOneKeywordSuccessAction,
  SetApiKeywordRequestStateAction,
  SetApiKeywordRequestErrorAction,
  SetApiKeywordsRequestStateAction,
  SetApiKeywordsRequestErrorAction,
  ResetKeywordAction,
} from './keywordTypes';
import { KeywordFilterValues, KeywordGetResponse, KeywordParams, KeywordValues } from '../model/keywordModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

export const setApiKeywordRequestState = (
  apiKeywordRequestState: API_REQUEST_STATE,
): SetApiKeywordRequestStateAction => ({
  type: KEYWORD_TYPES.SET_API_KEYWORD_REQUEST_STATE,
  payload: {
    apiKeywordRequestState: apiKeywordRequestState,
  },
});

export const setApiKeywordRequestError = (apiKeywordRequestError: string): SetApiKeywordRequestErrorAction => ({
  type: KEYWORD_TYPES.SET_API_KEYWORD_REQUEST_ERROR,
  payload: {
    apiKeywordRequestError: apiKeywordRequestError,
  },
});

export const setApiKeywordsRequestState = (
  apiKeywordsRequestState: API_REQUEST_STATE,
): SetApiKeywordsRequestStateAction => ({
  type: KEYWORD_TYPES.SET_API_KEYWORDS_REQUEST_STATE,
  payload: {
    apiKeywordsRequestState: apiKeywordsRequestState,
  },
});

export const setApiKeywordsRequestError = (apiKeywordsRequestError: string): SetApiKeywordsRequestErrorAction => ({
  type: KEYWORD_TYPES.SET_API_KEYWORDS_REQUEST_ERROR,
  payload: {
    apiKeywordsRequestError: apiKeywordsRequestError,
  },
});

export const addKeyword = (keyword: KeywordValues): AddKeywordAction => ({
  type: KEYWORD_TYPES.ADD,
  payload: {
    keyword: keyword,
  },
});

export const resetKeyword = (): ResetKeywordAction => ({
  type: KEYWORD_TYPES.RESET,
  payload: null,
});

export const editKeyword = (params: KeywordParams, keyword: KeywordValues): EditKeywordAction => ({
  type: KEYWORD_TYPES.EDIT,
  payload: {
    keyword: keyword,
    params: {
      id: params.id,
    },
  },
});

export const getAllKeywords = (keywordFilter: KeywordFilterValues): GetAllKeywordsAction => ({
  type: KEYWORD_TYPES.GET_ALL,
  payload: {
    keywordFilter: keywordFilter,
  },
});

export const getAllKeywordsSuccess = (keywords: KeywordGetResponse[]): GetAllKeywordsSuccessAction => ({
  type: KEYWORD_TYPES.GET_ALL_SUCCESS,
  payload: {
    keywords: keywords,
  },
});

export const getKeyword = (params: KeywordParams): GetOneKeywordAction => ({
  type: KEYWORD_TYPES.GET_ONE,
  payload: {
    params: {
      id: params.id,
    },
  },
});

export const getOneKeywordSuccess = (keyword: KeywordGetResponse): GetOneKeywordSuccessAction => ({
  type: KEYWORD_TYPES.GET_ONE_SUCCESS,
  payload: {
    keyword: keyword,
  },
});
